import { CreditRequestRequirement } from './credit-request-requirements';
import { CreditRequestRequirementRaw } from './credit-request-requirement-raw';
import { CreditProcessStatus, CreditStatus } from '../@core/constants';
import { CreditRequestData } from './credit-request-data';
import { Customer } from './customer';
import { User } from './user';

export class CreditRequest {
  amount: string;
  associatedCustomer: string;
  closed: string;
  code: string;
  comments: Array<string>;
  created: string;
  customer: Customer;
  extraInfo: any;
  idIdentificationType: string;
  limitRoule: string;
  modified: string;
  number: string;
  origin: string;
  procedure: string;
  processingMessage: string;
  processingStatus: CreditProcessStatus;
  requestData: CreditRequestData;
  requestType: string;
  requirements: CreditRequestRequirementRaw;
  requirementsArray: Array<CreditRequestRequirement>;
  salesOrgName: string;
  seller: User;
  status: Array<CreditStatus>;
  user: User;
  createdTimezoneDate: Date;
  modifiedTimezoneDate: Date;
  closedTimezoneDate: Date;

  //Customs
  company: string;
  division: string;
  identification: string;
  clientName: string;
  requestDataProcedure: string;
  createdDate: string;
  sellerName: string;
  firstStatus: string;
  createdHour: string;
  parsedStatus: string;
  isAval: string;

  branchCode: string;
  salesOrgCode: string;

  hasRequirements?: boolean;

  biometryLogCode:string;
  constructor() {
    this.amount = '';
    this.associatedCustomer = '';
    this.closed = '';
    this.code = '';
    this.comments = [];
    this.created = '';
    this.customer = new Customer();
    this.extraInfo = '';
    this.idIdentificationType = '';
    this.limitRoule = '';
    this.modified = '';
    this.number = '';
    this.origin = '';
    this.procedure = '';
    this.processingMessage = '';
    this.processingStatus = CreditProcessStatus.DRAFT;
    this.requestData = new CreditRequestData();
    this.requestType = '';
    this.requirements = {};
    this.requirementsArray = new Array();
    this.salesOrgName = '';
    this.seller = new User();
    this.status = [];
    this.user = new User();

    this.company = '';
    this.division = '';
    this.identification = '';
    this.clientName = '';
    this.requestDataProcedure = '';
    this.createdDate = '';
    this.createdHour = '';
    this.parsedStatus = '';
    this.isAval = '';

    this.sellerName = '';
    this.firstStatus = '';
    this.branchCode = '';
    this.salesOrgCode = '';

    this.createdTimezoneDate = new Date();
    this.closedTimezoneDate = new Date();
    this.modifiedTimezoneDate = new Date();

    this.biometryLogCode = '';
  }
}
